import { useState, useEffect } from "react";
import toastError from "../../errors/toastError";

import api from "../../services/api";

const useTicketTracking = ({ startDate, endDate, userId } = {}) => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState({ averageStatus: [], averageQueue: [], averageTransitions: [] });

    useEffect(() => {
        const fetchTrackingData = async () => {
            setLoading(true);
            try {
                const params = {};
                if (startDate) params.startDate = startDate;
                if (endDate) params.endDate = endDate;
                if (userId) params.userId = userId;

                const { data } = await api.get("/dashboard/tracking", { params });
                setData(data);
                setLoading(false);
            } catch (err) {
                setLoading(false);
                toastError(err);
            }
        };
        fetchTrackingData();
    }, [startDate, endDate, userId]);

    return { data, loading };
};

export default useTicketTracking;
